export const generateGoogleMapsUrl = (location: {
  name: string;
  street: string;
  city: string;
  state: string;
  zip: string;
}): string => {
  const updatedStreet = location.street.replace(/[\s,]*\b(Suite|Ste)\s*\d+/g, '').trim();
  const address = `${updatedStreet}, ${location.city}, ${location.state} ${location.zip}`;
  const googleMapsUrl = `https://www.google.com/maps/dir//${encodeURIComponent(address)}`;

  return googleMapsUrl;
};
